module.exports = __webpack_public_path__ + "img/1490396274.7021bb86.jpg";